import { ChipVariant } from "Components/atoms/chip";

export enum UserStatuses {
    Active = 'Active',
    Inactive = 'Inactive'
}

// Statuses are DB rows, so anything seeded later falls through to the default.
export const USER_STATUS_VARIANT: Record<string, ChipVariant> = {
    [UserStatuses.Active]: 'success',
    [UserStatuses.Inactive]: 'danger'
}

interface UserStatus {
    id: string
    description: string
}

export default UserStatus
